export const RANGE_MAX = 5_000_000_000

export enum TransactionVerificationStatus {
	Verified = "verified",
	Unverified = "unverified",
}
